import { render, staticRenderFns } from "./ShareOptionById.vue?vue&type=template&id=159db116&"
import script from "./ShareOptionById.vue?vue&type=script&lang=js&"
export * from "./ShareOptionById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports